import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

const PatientArrivalSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>3-1. 환자 도착 정보</h3>

      {/* 응급실 도착 시각 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">응급실 도착 시각</label>
          <div className="input_2col">
            <DateTimeInput
              id="ED_arrival_time_two"
              value={formData.ED_arrival_time_two || ""}
              onChange={(datetime) =>
                setFormData({
                  ...formData,
                  ED_arrival_time_two: datetime,
                })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <div className="input_2col"></div>
        </div>
      </div>

      {/* 병원 이송 수단 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">병원 이송 수단</label>
          <div className="input_1col">
            {[
              "119",
              "사설구급차",
              "병원구급차",
              "경찰차",
              "택시",
              "기타",
              "미상",
            ].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="Transport"
                  value={value}
                  checked={formData.Transport === value}
                  onChange={(e) =>
                    setFormData({ ...formData, Transport: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 소생실/중환구역 입실 시각 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">소생실/중환구역 입실 시각</label>
          <div className="input_2col">
            <DateTimeInput
              id="Resusci_room_time"
              value={formData.Resusci_room_time || ""}
              onChange={(datetime) =>
                setFormData({
                  ...formData,
                  Resusci_room_time: datetime,
                })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <div className="input_2col"></div>
        </div>
      </div>
    </section>
  );
};

export default PatientArrivalSection;
